export default __webpack_public_path__ + "static/media/ui-icon-wchip.acee684a.png";